/** Tạo thùng hàng loạt theo nhóm trên packing list (yêu cầu v1.8 mục 7.1, 11/10/2026). */
export const packingBatchEn = {
  open: "Create cartons in batch",
  title: "Create a group of identical cartons",
  hint: "Each carton of the group gets the next consecutive number, the same net / gross weight per carton and the same line with the same quantity. For cartons with other weights, create another group — it starts after the last number.",
  line: "PI line packed in every carton",
  choose: "Choose a line",
  lineOption: "{{code}} · {{description}} — {{remaining}} {{unit}} left",
  start: "Starting carton no.",
  count: "Number of cartons",
  qtyPerCtn: "Quantity per carton",
  nwPerCtn: "N.W. per carton (KG)",
  gwPerCtn: "G.W. per carton (KG)",
  measurement: "Measurement (optional)",
  preview: "Creates {{from}} – {{to}} · {{count}} cartons · {{qty}} {{unit}} of {{remaining}} left · N.W. {{nw}} kg · G.W. {{gw}} kg",
  create: "Create cartons",
  cancel: "Close",
  created: "Created {{count}} cartons: {{from}} – {{to}}.",
  err_start: "Starting carton number must be a whole number from 1.",
  err_count: "Number of cartons must be a whole number from 1 to {{max}}.",
  err_qty: "Quantity per carton must be a whole number above 0.",
  err_overPacked: "Quantity × cartons is more than the {{remaining}} left on this PI line.",
  err_nwKgs: "Enter the net weight per carton in KG.",
  err_gwKgs: "Enter the gross weight per carton in KG.",
  err_weights: "Gross weight cannot be lower than net weight.",
  err_collision: "Some of these carton numbers are already used on this packing list — change the starting number.",
  err_line: "Choose the PI line packed in these cartons.",
  runTitle: "{{from}} – {{to}}",
  runSummary: "{{count}} identical cartons · N.W. {{nw}} kg / carton · G.W. {{gw}} kg / carton",
  runItem: "{{code}} × {{qty}} {{unit}} per carton",
  runExpand: "Show each carton",
  runCollapse: "Collapse",
  runRemove: "Remove group",
  runRemoveTitle: "Remove this group of cartons?",
  runRemoveConfirm: "{{count}} cartons ({{from}} – {{to}}) will be removed from this packing list. Nothing is saved until you press Save.",
};

export const packingBatchVi: typeof packingBatchEn = {
  open: "Tạo thùng hàng loạt",
  title: "Tạo một nhóm thùng giống nhau",
  hint: "Mỗi thùng trong nhóm nhận số liên tiếp, cùng N.W. / G.W. mỗi thùng và cùng một dòng hàng với cùng số lượng. Thùng cân khác thì tạo thêm nhóm — nhóm mới bắt đầu sau số cuối.",
  line: "Dòng PI đóng trong mỗi thùng",
  choose: "Chọn dòng hàng",
  lineOption: "{{code}} · {{description}} — còn {{remaining}} {{unit}}",
  start: "Số thùng bắt đầu",
  count: "Số thùng",
  qtyPerCtn: "Số lượng mỗi thùng",
  nwPerCtn: "N.W. mỗi thùng (KG)",
  gwPerCtn: "G.W. mỗi thùng (KG)",
  measurement: "Kích thước (không bắt buộc)",
  preview: "Tạo {{from}} – {{to}} · {{count}} thùng · {{qty}} {{unit}} trên {{remaining}} còn lại · N.W. {{nw}} kg · G.W. {{gw}} kg",
  create: "Tạo thùng",
  cancel: "Đóng",
  created: "Đã tạo {{count}} thùng: {{from}} – {{to}}.",
  err_start: "Số thùng bắt đầu phải là số nguyên từ 1.",
  err_count: "Số thùng phải là số nguyên từ 1 đến {{max}}.",
  err_qty: "Số lượng mỗi thùng phải là số nguyên lớn hơn 0.",
  err_overPacked: "Số lượng × số thùng vượt {{remaining}} còn lại của dòng PI này.",
  err_nwKgs: "Nhập N.W. mỗi thùng theo KG.",
  err_gwKgs: "Nhập G.W. mỗi thùng theo KG.",
  err_weights: "G.W. không được nhỏ hơn N.W.",
  err_collision: "Một số số thùng này đã có trên phiếu — đổi số bắt đầu.",
  err_line: "Chọn dòng PI đóng trong các thùng này.",
  runTitle: "{{from}} – {{to}}",
  runSummary: "{{count}} thùng giống nhau · N.W. {{nw}} kg / thùng · G.W. {{gw}} kg / thùng",
  runItem: "{{code}} × {{qty}} {{unit}} mỗi thùng",
  runExpand: "Xem từng thùng",
  runCollapse: "Thu gọn",
  runRemove: "Xoá nhóm",
  runRemoveTitle: "Xoá nhóm thùng này?",
  runRemoveConfirm: "{{count}} thùng ({{from}} – {{to}}) sẽ bị bỏ khỏi phiếu đóng gói. Chưa lưu gì cho tới khi bấm Lưu.",
};

export const packingBatchZh: typeof packingBatchEn = {
  open: "批量创建箱号",
  title: "创建一组相同的箱",
  hint: "组内每箱依次编号，每箱净重 / 毛重相同，装同一明细、同一数量。重量不同的箱请再建一组——新组从上一组最后箱号之后开始。",
  line: "每箱所装 PI 明细",
  choose: "选择明细",
  lineOption: "{{code}} · {{description}} — 剩余 {{remaining}} {{unit}}",
  start: "起始箱号",
  count: "箱数",
  qtyPerCtn: "每箱数量",
  nwPerCtn: "每箱净重 (KG)",
  gwPerCtn: "每箱毛重 (KG)",
  measurement: "尺寸（选填）",
  preview: "创建 {{from}} – {{to}} · {{count}} 箱 · {{qty}} {{unit}}（剩余 {{remaining}}）· 净重 {{nw}} kg · 毛重 {{gw}} kg",
  create: "创建箱号",
  cancel: "关闭",
  created: "已创建 {{count}} 箱：{{from}} – {{to}}。",
  err_start: "起始箱号须为从 1 起的整数。",
  err_count: "箱数须为 1 至 {{max}} 的整数。",
  err_qty: "每箱数量须为大于 0 的整数。",
  err_overPacked: "数量 × 箱数超过该 PI 明细剩余的 {{remaining}}。",
  err_nwKgs: "请输入每箱净重（KG）。",
  err_gwKgs: "请输入每箱毛重（KG）。",
  err_weights: "毛重不能小于净重。",
  err_collision: "部分箱号已在本装箱单使用，请修改起始箱号。",
  err_line: "请选择装入这些箱的 PI 明细。",
  runTitle: "{{from}} – {{to}}",
  runSummary: "{{count}} 箱相同 · 每箱净重 {{nw}} kg · 每箱毛重 {{gw}} kg",
  runItem: "{{code}} × 每箱 {{qty}} {{unit}}",
  runExpand: "显示每一箱",
  runCollapse: "收起",
  runRemove: "删除整组",
  runRemoveTitle: "删除这组箱？",
  runRemoveConfirm: "将从装箱单移除 {{count}} 箱（{{from}} – {{to}}）。按保存前不会保存任何更改。",
};
